module.exports = __webpack_public_path__ + "static/img/coach.358bd30.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/coach/coach.jpg
// module id = B5jb
// module chunks = 38